import React, { Component } from "react";
import "./formButtons.scss";

class FormButtons extends Component {
  render() {
    const {
      firstOnClick, disableFirst,
      secondOnClick, disableSecond
    } = this.props;

    return (
      <>
        <div className="formButtons">
          <div className="col-50">
            <div className="col-50">
              {firstOnClick && (
                <button onClick={firstOnClick} disabled={disableFirst}>
                  Cadastrar
                </button>
              )}
            </div>
            <div className="col-50">
              {secondOnClick && (
                <button onClick={secondOnClick} disabled={disableSecond}>
                  Associar
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FormButtons;
